<template>
  <v-menu v-model="menu" offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn icon color="primary" dark elevation="0" v-on="on">
        <v-icon>mdi-calendar</v-icon>
      </v-btn>
    </template>
    <v-date-picker
      v-model="picker"
      @click="menu = false"
      :min="minVal"
      :max="maxVal"
    />
  </v-menu>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: new Date().toISOString().substr(0, 10)
    },
    min: {
      type: String,
      required: false,
      default: null
    },
    max: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      menu: false
    };
  },
  computed: {
    minVal() {
      if (this.min) {
        const d = new Date(this.min);
        const date = (d.getDate() + "").padStart(2, "0");
        const month = (d.getMonth() + 1 + "").padStart(2, "0");
        return `${d.getFullYear()}-${month}-${date}`;
      }
      return "";
    },
    maxVal() {
      if (this.max) {
        const d = new Date(this.max);
        const date = (d.getDate() + "").padStart(2, "0");
        const month = (d.getMonth() + 1 + "").padStart(2, "0");
        return `${d.getFullYear()}-${month}-${date}`;
      }
      return "";
    },
    picker: {
      get() {
        return this.value;
      },
      set(val) {
        this.menu = false;
        this.$emit("input", val);
      }
    }
  }
};
</script>
